export default __webpack_public_path__ + "static/media/photo--sm--142.e15234c2.jpg";